import type { CategoryInterface, NomenclatureGroupInterface } from '@/types'
import getPathForSelectedTreeNode from '@/utils/tree/nodes/getPathForSelectedTreeNode'
import { getTreeNodeDescription } from '@/utils/tree/nodes/treeNode'

export const getTreeNodePathLabels = (
  tree: CategoryInterface[] | NomenclatureGroupInterface[],
  selectedId: string | undefined
): string[] => {
  if (!selectedId) return []
  return (getPathForSelectedTreeNode(tree, selectedId) ?? []).map(
    getTreeNodeDescription
  )
}
